import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import translation from "~/i18n";

// Components
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import PageHeader from "~/common/components/PageHeader";
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import DropdownTemplate from "~/common/components/DropdownPortal/DropdownTemplate";

// Assets
import "~/assets/sass/pages/mypage/signature/signature.scss";
import SignaturePolicyModal from "./modal/policy/SignaturePolicyModal";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import { dateToString } from "~/utils/formatter";
import useAlert from "~/common/hooks/useAlert";
import File from "./modal/upload/components/File";

const SignaturePage = () => {
	const { t } = useTranslation();
	const MENU = ["admin", "signature"];
	const TYPE = "myPage";

	const [signatureList, setSignatureList] = useState([]);
	const [digitalDataModal, setDigitalDataModalModal] = useState(false);
	const [signatureUploadModal, setSignatureUploadModal] = useState(false);
	const userSignatureRequest = useRequest("get", "vc/admin/signature");
	const activationSignRequest = useRequest("post", "/vc/admin/signature/activation");
	const deleteSignRequest = useRequest("delete", "/vc/admin/signature/delete");

	const [showWarningAlert, Warning] = useAlert();

	useEffect(() => {
		userSignatureRequest.singleCall();
	});

	useEffect(() => {
		switch (userSignatureRequest.state) {
			case API_STATE.done:
				const newData = userSignatureRequest.response.data;
				newData.map((sign) => ({
					...sign,
					updateDate: dateToString(sign.updateDate, "yyyy-MM-dd"),
				}));
				setSignatureList(newData);
				break;
			case API_STATE.error:
				console.log("error", userSignatureRequest.error);
				break;
			default:
				break;
		}
	}, [userSignatureRequest.state, userSignatureRequest.response, userSignatureRequest.error]);

	const handleActive = (idx) => {
		activationSignRequest.call(idx, "path");
	};

	useEffect(() => {
		switch (activationSignRequest.state) {
			case API_STATE.done:
				userSignatureRequest.call();
				break;
			case API_STATE.error:
				console.log("error", activationSignRequest.error);
				break;
			default:
				break;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activationSignRequest.state, activationSignRequest.error, activationSignRequest.response]);

	const handleDelete = (idx) => {
		deleteSignRequest.call(idx, "path");
	};

	useEffect(() => {
		switch (deleteSignRequest.state) {
			case API_STATE.done:
				userSignatureRequest.call();
				break;
			case API_STATE.error:
				console.log("error", deleteSignRequest.error);
				break;
			default:
				break;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [deleteSignRequest.state, deleteSignRequest.error, deleteSignRequest.response]);

	const headerButtons = [
		<button
			type="button"
			className="btn__solid"
			color="primary"
			onClick={() => {
				if (signatureList?.length >= 6) return showWarningAlert();
				setDigitalDataModalModal(true);
			}}
		>
			{t("common.commonWord.button.add")}
		</button>,
	];

	return (
		<>
			<NavbarAndSidebarLayout menu={MENU} type={TYPE}>
				<PageHeader hasBreadCrumb={true} buttonList={headerButtons} />
				<div className="c__cardRow">
					{signatureList.map((s) => (
						<div key={s.idx} className={`c__card ${s.activation && "active"}`}>
							{s.activation && (
								<div className="c__badge">
									{t("common.commonWord.button.active")}
								</div>
							)}
							<DropdownTemplate target={s.idx} vertical>
								<li className="c__dropdownItem" onClick={() => handleActive(s.idx)}>
									{s.activation
										? translation.t("common.commonWord.button.inactive")
										: translation.t("common.commonWord.button.active")}
								</li>

								<li className="c__dropdownItem" onClick={() => handleDelete(s.idx)}>
									{t("common.commonWord.button.delete")}
								</li>
							</DropdownTemplate>
							<div className="img-wrap">
								<img
									src={s.img}
									alt={t("pages.myPage.SignaturePage.signImg")}
									className={s.type === "IMG" ? "sign-img" : ""}
								/>
							</div>
							<p className="date">Updated: {s.updateDate}</p>
						</div>
					))}
				</div>
				{/*//---- Empty*/}
				{/*<div className="page-init">*/}
				{/*	<p className="main">법인인감이 존재하지 않습니다.</p>*/}
				{/*	<p className="sub">우측 상단의 추가하기를 클릭하여 법인인감을 추가해 보세요.</p>*/}
				{/*<img src={darkInitImg} alt="초기이미지" />*/}
				{/*<img src={lightInitImg} alt="초기이미지" />*/}
				{/*</div>*/}
			</NavbarAndSidebarLayout>

			{/* POLICY */}
			<ModalTemplate
				title={t("pages.myPage.admin.SignaturePage.digitalDataModal")}
				modalState={digitalDataModal}
				setModalToggle={setDigitalDataModalModal}
				width={500}
				height={502}
				className="digital-data-modal"
			>
				<SignaturePolicyModal
					setSignatureUploadModal={setSignatureUploadModal}
					setDigitalDataModalModal={setDigitalDataModalModal}
				/>
			</ModalTemplate>

			{/* UPLOAD */}
			<ModalTemplate
				title={t("pages.myPage.admin.SignaturePage.signatureUploadModal")}
				modalState={signatureUploadModal}
				setModalToggle={setSignatureUploadModal}
				width={500}
				height={380}
				className="signatureUpload-modal"
			>
				<div className="modal-content">
					<div className={`signature-file`}>
						<File
							setModalToggle={setSignatureUploadModal}
							userSignatureRequest={userSignatureRequest}
						/>
					</div>
				</div>
			</ModalTemplate>

			<Warning
				type="info"
				message={"법인 인감은 최대 6개까지 등록할 수 있습니다."}
				subMessage="삭제 후 추가해주세요."
				confirm={t("pages.round.RoundReg.container.RoundRegContainer.confirm")}
			/>
		</>
	);
};
export default SignaturePage;
